import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import { Button } from './Button';
import { convertirLetraMayus } from '../../../../helpers/convertirLetraMayus';
import { AnimatePresence, motion } from "framer-motion";

export const PqrsResponse = (props) => {

    const [comment, setComment] = useState('');
    const [optSelected, setOptSelected] = useState('');
    const { action, options } = props;
    const classes = useStyles();

    return (
        <Grid container justifyContent='center'>
            <Grid item xs={ 11 } sm={ 11 } md={ 11 } lg={ 11 }>

                <Grid container spacing={1} marginTop={2} marginBottom={3}>
                    { options?.map(o => (
                        <Grid key={ o } item xs={ 6 } sm={ 6 } md={ 3 } lg={ 3 }>
                            <motion.button
                                key={ o }
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 1 }}
                                type='submit'
                                onClick={ () => setOptSelected(o) }
                                className={ `${ classes.buttons } ${ optSelected?.includes(o) ? classes.activeButton : classes.inactiveButton }` }
                            >{ convertirLetraMayus(o) }</motion.button>
                        </Grid>
                    ))}
                </Grid>
                
                <motion.textarea 
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className={ classes.area } 
                    rows={ 4 } 
                    onChange={ (e) => setComment(e?.target?.value) } 
                    placeholder="Ingresa un comentario para continuar"
                />

                <div className={ classes.groupBtns }>
                    <AnimatePresence>
                        {
                            (optSelected && comment) ? (
                                <Button
                                    title='Continuar'
                                    action={ () => action(comment?.toLowerCase().trim(), optSelected) }
                                    directionX='flex-end'
                                    breakPoints={[6, 5, 4, 4]}
                                />
                            ) : !optSelected && (
                                <Button
                                    title='No, gracias'
                                    action={ () => action('Ninguna') }
                                    directionX='flex-end'
                                    breakPoints={[5, 4, 3, 3]}
                                    type='text'
                                />
                            )
                        }
                    </AnimatePresence>
                </div>
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles({
    area: {
        borderRadius: 6,
        padding: 10,
		letterSpacing: '1px',
        resize: 'none',
        fontSize: 'clamp(.8rem, 4vw, .9rem)',
        width: '100%',
    },
    groupBtns: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: 15
    },
    span: {
        color: '#fff',
        marginLeft: 20,
        marginRight: 20,
        cursor: 'pointer'
    },
    buttons: {
        width: '100%',
        padding: '12px 25px',
        borderRadius: 32,
        fontWeight: 600,
        letterSpacing: 1.5,
        fontSize: 'clamp(.9rem, 4vw, 1rem)',
        minWidth: '5em',
        cursor: 'pointer'
    },
    activeButton: {
        background: '#977600',
        color: '#fff',
        border: 'none'
    },
    inactiveButton: {
        background: '#fff',
        color: '#977600',
        border: '2px solid #977600',
    }
});